import type { ComponentType } from 'react'

import { RouteActionErrorListener } from './RouteActionErrorListener'

export function withRouteErrorListener<P extends object>(Component: ComponentType<P>) {
  return function RouteWithErrorListener(props: P) {
    return (
      <>
        <RouteActionErrorListener />
        <Component {...props} />
      </>
    )
  }
}
